<template>
  <div>
    <div v-if="showCustomerFilter" class="content-body">
      <div class="row mt-2">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-5">
                  <div class="form-group mb-0">
                    <label>Selecionar Cliente</label>
                    <select v-model="customerId" class="form-control custom-select">
                      <option :value="null">Todos os clientes</option>
                      <option v-for="customer in customers" :key="customer._id" :value="customer._id">
                        {{ customer.trade_name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="form-group mb-0">
                    <label>Selecionar Equipe</label>
                    <select v-model="teamId" class="form-control custom-select">
                      <option :value="null">Todas as equipes</option>
                      <option v-for="team in teams" :key="team._id" :value="team._id">
                        {{ team.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 d-flex align-items-end">
                  <button class="btn btn-primary btn-block" @click="debounceLoadData">Filtrar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="row mt-2">
        <div class="col-12">
          <div class="card">
            <div class="card-header d-flex flex-column pb-0 align-items-start">
              <div><h4 class="card-title mb-1">Status dos Tickets | Por mês</h4></div>
              <div><small class="text-muted">Quantidade de tickets abertos, fechados, cancelados ou aguardando finalização de outro ticket no mês de referência."</small></div>
            </div>
            <div class="pl-2 pr-2 position-relative">
              <div v-show="loadingAllTickets" class="text-center p-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Carregando...</span>
                </div>
              </div>
              <bar-chart v-show="!loadingAllTickets" ref="chartBarLine" :chartdata="seriesAllTickets" :options="options" @bar-click="onAllTicketsBarClick"></bar-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="row mt-2">
        <div class="col-12">
          <div class="card">
            <div class="card-header d-flex flex-column pb-0 align-items-start">
              <div><h4 class="card-title mb-1">Status da primeira entrega | Por mês</h4></div>
              <div><small class="text-muted">Tickets que tiveram a primeira entrega no antes do prazo, no prazo ou depois do prazo no mês de referência.</small></div>
            </div>
            <div class="pl-2 pr-2 position-relative">
              <div v-show="loadingFirstDelivery" class="text-center p-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Carregando...</span>
                </div>
              </div>
              <bar-chart v-show="!loadingFirstDelivery" ref="chartFirstDelivery" :chartdata="seriesFirstDelivery" :options="options" @bar-click="onFirstDeliveryBarClick"></bar-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="row mt-2">
        <div class="col-12">
          <div class="card">
            <div class="card-header d-flex flex-column pb-0 align-items-start">
              <div><h4 class="card-title mb-1">Seus tickets hoje | Por setor da agência</h4></div>
              <div><small class="text-muted">Veja qual setor da agência está trabalhando nos tickets em andamento.</small></div>
            </div>
            <div class="pl-2 pr-2 position-relative">
              <div v-show="loadingTicketsArea" class="text-center p-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Carregando...</span>
                </div>
              </div>
              <bar-chart v-show="!loadingTicketsArea" ref="chartTicketsArea" :chartdata="seriesTicketsArea" :options="options" @bar-click="onTicketsAreaBarClick"></bar-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="row mt-2">
        <div class="col-12">
          <div class="card">
            <div class="card-header d-flex flex-column pb-0 align-items-start">
              <div><h4 class="card-title mb-1">Estatísticas de consumo do contrato</h4></div>
              <div><small class="text-muted">Evolução mês a mês do seu contrato, com horas/escudos contratados, consumidos e o saldo acumulado para o mês seguinte.</small></div>
            </div>
            <div class="pl-2 pr-2 position-relative">
              <div v-show="loadingTime" class="text-center p-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Carregando...</span>
                </div>
              </div>
              <bar-chart v-show="!loadingTime" ref="chartBarLineTime" :chartdata="seriesTime" :options="options"></bar-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { H } from 'hennig-common'
import BarChart from './CustomerBarChart'

export default {
  name: 'CustomerReports',
  components: {
    'bar-chart': BarChart,
  },
  props: {
    showCustomerFilter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      customerId: null,
      teamId: null,
      customers: [],
      teams: [],
      seriesAllTickets: {},
      seriesFirstDelivery: {},
      seriesTime: {},
      seriesTicketsArea: {},
      phaseIds: [],
      monthValues: [],
      monthValuesFirstDelivery: [],
      loadingAllTickets: false,
      loadingTicketsArea: false,
      loadingFirstDelivery: false,
      loadingTime: false,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          intersect: false
        }
      }
    }
  },
  watch: {
    customerId (val) {
      if (val) {
        this.teamId = null
      }
      this.debounceLoadData()
    },
    teamId (val) {
      if (val) {
        this.customerId = null
      }
      this.debounceLoadData()
    }
  },
  mounted () {
    if (this.showCustomerFilter) {
      H.rpc('Dashboard', 'listCustomers', [], (r) => {
        if (r) {
          this.customers = r
        }
      })
      H.rpc('Dashboard', 'listTeams', [], (r) => {
        if (r) {
          this.teams = r
        }
      })
    }
    this.loadData()
  },
  methods: {
    debounceLoadData () {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.loadData()
      }, 500)
    },
    loadData () {
      this.loadAllTicketsData()
      setTimeout(() => this.loadTicketsAreaData(), 200)
      setTimeout(() => this.loadHoursData(), 500)
      setTimeout(() => this.loadFirstDeliveryData(), 800)
    },
    loadAllTicketsData () {
      let self = this
      let params = { customerId: this.customerId, teamId: this.teamId }
      this.loadingAllTickets = true
      H.rpc('Dashboard', 'CustomerAllTicketsData', [params], (r) => {
        this.loadingAllTickets = false
        if (r) {
          self.seriesAllTickets.labels = r.labels
          self.seriesAllTickets.datasets = r.infos
          self.monthValues = r.monthValues
          this.$nextTick(() => {
            if (self.$refs.chartBarLine) {
              self.$refs.chartBarLine.renderChart(self.seriesAllTickets, self.options)
            }
          })
        }
      })
    },
    loadTicketsAreaData () {
      let self = this
      let params = { customerId: this.customerId, teamId: this.teamId }
      this.loadingTicketsArea = true
      H.rpc('Dashboard', 'CustomerTicketsData', [params], (r) => {
        this.loadingTicketsArea = false
        if (r) {
          self.seriesTicketsArea.labels = r.labels
          self.seriesTicketsArea.datasets = r.infos
          self.phaseIds = r.phaseIds
          this.$nextTick(() => {
            if (self.$refs.chartTicketsArea) {
              self.$refs.chartTicketsArea.renderChart(self.seriesTicketsArea, self.options)
            }
          })
        }
      })
    },
    loadFirstDeliveryData () {
      let self = this
      let params = { customerId: this.customerId, teamId: this.teamId }
      this.loadingFirstDelivery = true
      H.rpc('Dashboard', 'CustomerFirstDeliveryData', [params], (r) => {
        this.loadingFirstDelivery = false
        if (r) {
          self.seriesFirstDelivery.labels = r.labels
          self.seriesFirstDelivery.datasets = r.infos
          self.monthValuesFirstDelivery = r.monthValues
          this.$nextTick(() => {
            if (self.$refs.chartFirstDelivery) {
              self.$refs.chartFirstDelivery.renderChart(self.seriesFirstDelivery, self.options)
            }
          })
        }
      })
    },
    loadHoursData () {
      let self = this
      let params = { customerId: this.customerId, teamId: this.teamId }
      this.loadingTime = true
      H.rpc('Dashboard', 'CustomerHours', [params], (r) => {
        this.loadingTime = false
        if (r) {
          self.seriesTime.labels = r.labels
          self.seriesTime.datasets = r.infos
          this.$nextTick(() => {
            if (self.$refs.chartBarLineTime) {
              self.$refs.chartBarLineTime.renderChart(self.seriesTime, self.options)
            }
          })
        }
      })
    },
    onAllTicketsBarClick (data) {
      let label = this.seriesAllTickets.datasets[data.datasetIndex].label
      let monthValue = this.monthValues[data.index]
      let dateStart = monthValue + '-01 00:00:00'
      let dateEnd = monthValue + '-31 23:59:59'

      let query = {
        status: ''
      }

      if (label === 'Aberto') {
        query.created_at_i = dateStart
        query.created_at_f = dateEnd
      } else {
        query.updated_at_i = dateStart
        query.updated_at_f = dateEnd
        query.status = label
      }

      this.$router.push({ name: 'Tickets', query }).catch(err => {
        if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected when going from')) {
          console.error(err)
        }
      })
    },
    onFirstDeliveryBarClick (data) {
      let label = this.seriesFirstDelivery.datasets[data.datasetIndex].label
      let monthValue = this.monthValuesFirstDelivery[data.index]

      let statusMap = {
        'Antes do prazo': 'before',
        'No prazo': 'on_time',
        'Depois do prazo': 'after'
      }

      let query = {
        first_delivery_month: monthValue,
        first_delivery_type: statusMap[label]
      }
      if (this.customerId) {query.customer_id = this.customerId}
      if (this.teamId) {query.team_id = this.teamId}

      this.$router.push({ name: 'Tickets', query }).catch(err => {
        if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected when going from')) {
          console.error(err)
        }
      })
    },
    onTicketsAreaBarClick (data) {
      let phaseId = this.phaseIds[data.index]

      let query = {
        phase_id: phaseId,
        status: ['Aberto', 'Aguardando']
      }

      this.$router.push({ name: 'Tickets', query }).catch(err => {
        if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected when going from')) {
          console.error(err)
        }
      })
    },

  }
}
</script>
